export default {"src":"/_next/static/media/close-icon.c9987bc3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};